'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default function projectContactTable() {
    return {
        restrict: 'A',
        template: require('../../../../../view/table.html'),
        transclude: false,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            edit: '=edit',
        },
        controller: ['$scope', '$utils', 'StaffService',
            function ($scope, $utils, StaffService) {

                $scope.refresh = refresh;
                $scope.dblClick = dblClick;
                $scope.select = select;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;

                init();

                // region Function

                function init() {

                    if (!$scope.selectedItem)
                        $scope.selectedItem = {};

                    $scope.columns = [{
                        name: "Фамилия Имя Отчество",
                        data: "fullName"
                    }, {
                        name: "Должность",
                        data: "position"
                    }, {
                        name: "Телефон",
                        data: "phone"
                    }, {
                        name: "Факс",
                        data: "fax"
                    }, {
                        name: "E-mail",
                        data: "email"
                    }, {
                        name: "Messenger",
                        data: "skype"
                    }];

                    $scope.searching = {
                        isSearch: $scope.isSearch,
                        filter: null
                    };

                    $scope.pagination = {
                        isPaging: $scope.isPaging,
                        page: 1,
                        size: $scope.isPaging ? 10 : null,
                        totalPages: null,
                        totalItems: null
                    };

                    $scope.toolbox = {
                        buttons: {
                            create: {
                                show: () => $scope.edit,
                                click: () => StaffService.select({}, ["'org.mizip' EQ 'true'"], {}).result.then(function (data) {
                                    if (!$scope.items.some(item => item.id == data.id)) {
                                        $scope.items.push(data);
                                    }
                                }),
                                disabled: () => false,
                            },
                            remove: {
                                show: () => $scope.edit,
                                click: (item) => $scope.items.splice($scope.items.indexOf($scope.items.find(it => it.id == item.id)), 1),
                                disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                            },
                            refresh: {
                                show: () => false,
                                click: $scope.refresh,
                                disabled: () => false,
                            },
                        }
                    };
                }

                function refresh() {
                    if (Array.isArray($scope.items)) {
                        if ($scope.items.every(i => i.id != $scope.selectedItem.id)) {
                            $scope.selectedItem = {};
                        }
                    }
                }

                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table' :
                            if ($scope.toolbox.buttons.edit) {
                                $scope.toolbox.buttons.edit.click(item);
                            }
                            break;
                        case 'select' :
                            $scope.ok(item);
                            break;
                    }
                }

                function select(item) {
                    if ($scope.selectedItem.id !== item.id) {
                        angular.copy(item, $scope.selectedItem);
                    } else {
                        angular.copy({}, $scope.selectedItem);
                    }
                }

                function isSelect(item) {
                    return $scope.selectedItem != null ? $scope.selectedItem.id === item.id : false;
                }

                function getItems() {
                    return $scope.items;
                }

                // endregion

            }]
    };
}